import React, { useState } from "react";
import '../../style.scss';
import './style.scss';
import { Modal, Button, Table } from "antd";
import imgPacket from "assets/imgs/QrCodeMyVnptVer2/img-roaming-packet.png";
import star from "assets/imgs/QrCodeMyVnptVer2/star.png";
import downIcon from "assets/imgs/QrCodeMyVNPT/down-icon.png";
import { cycleMapping, formatVND } from "pages/QrCodeMyVnptVer2/constant/contanst";

const PackageInfo = ({ data }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenScope, setIsOpenScope] = useState(true);
  const [isOpenCancelPackage, setIsOpenCancelPackage] = useState(true);
  const hotPromotion = data?.hotPromotion ? JSON.parse(data?.hotPromotion) : [];

  const columns = [
    {
      title: 'Quốc gia',
      dataIndex: 'nationalName',
      fixed: 'left',
      width: 100,
      key: 'nationalName',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Nhà mạng',
      dataIndex: 'carrierNameVn',
      key: 'carrierNameVn',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Tên hiển thị',
      dataIndex: 'handsetDisplayVn',
      key: 'handsetDisplayVn',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Trả trước',
      dataIndex: 'prepaidStatus',
      key: 'prepaidStatus',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Trả sau',
      dataIndex: 'postpaidStatus',
      key: 'postpaidStatus',
      render: (text) => <span>{text}</span>,
    },
  ];

  const dataApplicableScope = data?.groupNationalityScopes?.map(e => ({
    nationalName: e?.nationality?.nameVn,
    carrierNameVn: e?.carrierNameVn,
    handsetDisplayVn: e?.handsetDisplayVn,
    prepaidStatus: e?.prepaidStatus,
    postpaidStatus: e?.postpaidStatus,
  }));

  return (
  <div className="detail-roaming-package">
    <div className="detail-roaming-package-top">
      <div className="roaming-package-top-img">
        <img src={data?.imageUrl} alt="" />
      </div>
      <div className="roaming-package-top-title">
        <div className="title">Gói cước {data?.packageName}</div>
        <div className="rating">
          <div className="img-star">
            <img src={star} alt="" />
          </div>
          <div className="point-rating">{data?.starRates}</div>
        </div>
      </div>
    </div>
    
    <div className="divider"></div>

    <div className='desc-roaming-package'>
      {
        hotPromotion?.map((e) => (
          <div key={e?.key} className='desc-item'>
            <div className='desc-item-key'>{e?.key}</div>
            <div className='desc-item-value'>{e?.value}</div>
          </div>
        ))
      }

      {
        data?.cycleDesc && (
          <div className='desc-item'>
            <div className='desc-item-key'>Chu kỳ</div>
            <div className='desc-item-value'>{data.cycleDesc}</div>
          </div>
        )
      }

      <div className='desc-item'>
        <div className='desc-item-key'>Giá cước / chu kỳ</div>
        <div className='desc-item-value text-blue'>{formatVND(data?.price)}</div>
      </div>
    </div>

    <div className="divider"></div>

    <div className="intro-roaming-package">
      <div className="intro-top" onClick={() => setIsOpen(!isOpen)}>
        <div>Giới thiệu chung</div>
        <img className={`arrow ${isOpen ? "open" : ""}`} src={downIcon} alt="down-icon" />
      </div>

      <div className={`intro-content ${isOpen ? "open" : ""}`}>
        <div className="package-item-des" dangerouslySetInnerHTML={{ __html: data?.fullDescription }} />
        {/* <div className="intro-item">
          <div className="intro-item-title">1. Giới thiệu</div>
          <div className="intro-item-content">Gói cước VD149 - Giải pháp hoàn hảo cho Quý khách có nhu cầu sử dụng đồng thời nhiều dịch vụ (thoại, sms, data) khi chuyển vùng quốc tế, với giá rẻ hơn cước thông thường.</div>
        </div> */}
      </div>

      <div className="intro-top" onClick={() => setIsOpenScope(!isOpenScope)}>
        <div>Phạm vi áp dụng</div>
        <img className={`arrow ${isOpenScope ? "open" : ""}`} src={downIcon} alt="down-icon" />
      </div>

      <div className={`intro-content ${isOpenScope ? "open" : ""}`}>
        <Table
          columns={columns}
          dataSource={dataApplicableScope}
          scroll={{ x: 600 }}
          pagination={false}
          rowKey={(record) => record.nationalName}
        />
      </div>

      {data?.instructionsVi && (
        <>
          <div className="intro-top" onClick={() => setIsOpenCancelPackage(!isOpenCancelPackage)}>
            <div>Hướng dẫn Huỷ gói cước</div>
            <img className={`arrow ${isOpenCancelPackage ? "open" : ""}`} src={downIcon} alt="down-icon" />
          </div>

          <div className={`intro-content ${isOpenCancelPackage ? "open" : ""}`}>
            <div className="package-item-des" dangerouslySetInnerHTML={{ __html: data?.instructionsVi }} />
          </div>
        </>
      )}
    </div>
  </div>
  );
};

export default PackageInfo;
